import { assetTypeService } from "@features/assetType/assetTypeService";
import { AssetTypeOutputDTO } from "@features/assetType/types";
import createEntitySlice from "@services/createEntitySlice";

const {
  reducer: assetTypeReducer,
  actions: assetTypeActions,
  fetchAll: fetchAssetTypes,
  fetchById: fetchAssetTypeById,
  createEntity: createAssetType,
  updateEntity: updateAssetType,
  deleteEntity: deleteAssetType,
} = createEntitySlice<AssetTypeOutputDTO>("assetType", assetTypeService);

export {
  assetTypeReducer,
  assetTypeActions,
  fetchAssetTypes,
  fetchAssetTypeById,
  createAssetType,
  updateAssetType,
  deleteAssetType,
};